import React from 'react'
import moment from 'moment'

import CustomDatePicker from 'components/CustomDatePicker'

const ByDate  = () => {
  return (
    <div className="form-group">
      <CustomDatePicker
        model=".date_from"
        label="Date From/To"
        maxDate={moment()}
        disabledKeyboardNavigation
      />
      <CustomDatePicker
        model=".date_to"
        maxDate={moment()}
        disabledKeyboardNavigation
      />
    </div>
  )
}

export default ByDate



// WEBPACK FOOTER //
// ./src/containers/Reports/Collections/by-date.js